import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';

import { GiftCode } from '@/models/GiftCode';

type GiftCodeTableProps = {
  // eslint-disable-next-line react/require-default-props
  giftCodes?: GiftCode[];
};

const columns: ColumnsType = [
  {
    title: 'コード',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: '金額',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: '配信済みか',
    dataIndex: 'isUsed',
    render: (_: any, row: GiftCode) => (row.isUsed ? '済' : '未'),
  },
];

const GiftCodeTable: React.FC<GiftCodeTableProps> = ({ giftCodes }) => {
  if (!giftCodes || giftCodes.length < 1) {
    return <div />;
  }

  return <Table columns={columns} dataSource={giftCodes} rowKey={(giftCode: GiftCode) => giftCode.hash} />;
};

export default GiftCodeTable;
